import { render, staticRenderFns } from "./CadastrarEditarDisciplinaDialog.vue?vue&type=template&id=1598bc0c"
import script from "./CadastrarEditarDisciplinaDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarDisciplinaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports